import React, { useEffect, useRef, useState } from "react";
import { FlexRow, H1, Button } from "appStyles";
import styled, { css } from "react-emotion";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import {
  withRedux,
  priceToDollars,
  formatDollarsToCents,
  parseQuery,
  isMobileDevice,
} from "helpers";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
} from "@material-ui/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;

const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

const tableRowClickable = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
`;
const tableRowClickableMobile = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
  border: 1px solid rgb(173, 173, 166);
  text-align: center;
  // padding: 10px;
  border-radius: 5px;
  margin: 20px 0px;
`;

const boldButton = css`
  display: inline-block;
  width: auto;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: rgba(120, 120, 120, 0.5);
`;

const headerText = css`
  text-align: center;
  font-size: 1.5em;
  margin: 0px;
  @media only screen and (min-width: 768px) {
    text-align: center;
    font-size: 2.5em;
    margin: 0px;
  }
`;

const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#F17F7F",
    },
    secondary: {
      main: "#88d1d4",
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiTablePagination: {
      // Name of the rule
      actions: {
        // Some CSS
        marginLeft: "0px",
      },
    },
    MuiTableContainer: {
      root: {
        flex: 1,
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        width: "100%",
      },
    },
    MuiTableSortLabel: {
      root: {
        color: "#89D2D3 !important",
      },
    },
  },
});

function Invoices(props) {
  const {
    platformInfo: { status: user },
    invoices,
    actions: {
      getInvoicesForApp,
      getInvoicesMetadataForApp,
      setInvoices,
      getInvoiceById,
    },
  } = props;
  // console.log("got invoices from redux store!");
  // console.dir(invoices);

  const isMob = isMobileDevice();
  const [accessToken, setAccessToken] = useState(null);

  const getAppIdFromUrl = () => {
    const path = props.history.location.pathname;
    const appId = parseInt(
      path.substring(5, path.lastIndexOf("/admin/invoices"))
    );
    return appId;
  };

  const getInvoices = async () => {
    console.log("fetching invoices....");
    const appId = getAppIdFromUrl();
    let accessToken = null;
    if (!user.user) {
      const query = parseQuery(props.history.location.search);
      console.log(
        "no logged in user detected, fetching access token from url..."
      );
      console.log(query);

      accessToken = query.accessToken;
      console.log(accessToken);
      setAccessToken(accessToken);
    }
    try {
      const invoicesObject = await getInvoicesMetadataForApp(
        appId,
        accessToken
      );
      // console.log("GOT INVOICES: ");
      // console.dir(invoicesObject);
      setInvoices(invoicesObject);
      props.actions.updateActiveEditor("newInvoice");
      return invoicesObject;
    } catch (e) {
      console.error(e);
    }
  };
  const scrollTo = (ref) => {
    if (ref && props.history.action === "PUSH" /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
      props.history.action = "POP";
    }
  };

  const goBack = () => {
    props.history.push("/application");
  };

  useEffect(() => {
    getInvoices();
  }, []);

  const createInvoice = () => {
    props.actions.addTempInvoice(getAppIdFromUrl());
    props.actions.updateActiveEditor("newInvoice");
    props.history.push("/invoices", { accessToken });
  };

  const openInvoiceDetails = async (id) => {
    const appId = getAppIdFromUrl();
    // console.log("fetching invoice by id...");
    props.actions.getInvoiceById(appId, id, accessToken).then((invoice) => {
      props.actions.addTempInvoice(getAppIdFromUrl(), invoice);
      props.actions.updateActiveEditor(id);
      props.history.push("/invoices", { accessToken });
    });
  };

  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <a ref={scrollTo}></a>
      <div>
        {user.user && (
          <div className={storeContainer}>
            <FontAwesomeIcon
              className={arrowStyle}
              icon="arrow-left"
              onClick={goBack}
            />
          </div>
        )}

        <div className={storeContainer}>
          <FlexRow className={headerContainer}>
            <H1 className={headerText}>Invoices</H1>
          </FlexRow>
          <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={createInvoice}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "center",
                marginLeft: "20px",
                height: "42px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              + Create Invoice
            </Button>
          </FlexRow>{" "}
          {isMob ? (
            <div>
              {Object.keys(invoices)
                .reverse()
                .map((id) => {
                  // console.log(id);
                  const invoice = invoices[id];
                  if (invoice.id === "newInvoice") return null;
                  const parsedCreatedDate = new Date(
                    invoice.createdDate
                  ).toLocaleDateString("en-US");
                  const { customerName, status, name, total } = invoice;
                  // console.dir(invoice);
                  return (
                    <div
                      key={invoice.id}
                      className={tableRowClickableMobile}
                      onClick={() => openInvoiceDetails(id)}
                    >
                      <div
                        style={{
                          backgroundColor: "rgb(137, 210, 211)",
                          padding: "10px",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            color: status !== "VOID" ? "white" : "#ADADA6",
                            fontWeight: "bold",
                          }}
                        >
                          <span>Invoice #</span>
                          <span>{id}</span>{" "}
                        </div>
                      </div>
                      <div style={{ padding: "10px" }}>
                        <p
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                            textAlign: "right",
                          }}
                        >
                          {status && typeof status === "string"
                            ? "Status: " + status.toProperCase()
                            : ""}
                        </p>
                        <div
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                            fontSize: "1.05rem",
                          }}
                        >
                          <span>{name}</span>{" "}
                        </div>
                        <div>
                          <p
                            style={{
                              color: status !== "VOID" ? "black" : "#ADADA6",
                              textAlign: "left",
                              paddingTop: "10px",
                            }}
                          >
                            Customer : {customerName ? customerName : ""}
                          </p>
                          <p
                            style={{
                              color: status !== "VOID" ? "black" : "#ADADA6",
                              textAlign: "left",
                              paddingTop: "10px",
                            }}
                          >
                            Created : {parsedCreatedDate}
                          </p>
                          <p
                            style={{
                              color: status !== "VOID" ? "black" : "#ADADA6",
                              textAlign: "right",
                              paddingTop: "10px",
                            }}
                          >
                            Total : {priceToDollars(total)}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <Table
              style={{
                borderCollapse: "collapse",
                margin: "auto",
                marginTop: "50px",
                marginBottom: "50px",
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    textAlign: "left",
                    borderBottom: "1pt solid black",
                    backgroundColor: "#89d2d3",
                    color: "white",
                  }}
                >
                  <TableCell style={{ width: "40%", lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Name
                    </P>
                  </TableCell>

                  <TableCell style={{ lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Invoice #
                    </P>
                  </TableCell>

                  <TableCell style={{ lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Total
                    </P>
                  </TableCell>
                  <TableCell style={{ lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Customer Name
                    </P>
                  </TableCell>
                  <TableCell style={{ lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Created Date
                    </P>
                  </TableCell>
                  <TableCell style={{ lineHeight: "0.5em" }}>
                    <P
                      style={{
                        padding: "0px 0px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Status
                    </P>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(invoices)
                  .reverse()
                  .map((id) => {
                    // console.log(id);
                    const invoice = invoices[id];
                    if (invoice.id === "newInvoice") return null;
                    const parsedCreatedDate = new Date(
                      invoice.createdDate
                    ).toLocaleDateString("en-US");
                    const { customerName, status, name, total } = invoice;
                    // console.dir(invoice);
                    return (
                      <TableRow
                        key={invoice.id}
                        className={tableRowClickable}
                        onClick={() => openInvoiceDetails(id)}
                      >
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {name}
                        </TableCell>
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {id}
                        </TableCell>
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {priceToDollars(total)}
                        </TableCell>
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {customerName ? customerName : ""}
                        </TableCell>
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {parsedCreatedDate}
                        </TableCell>
                        <TableCell
                          style={{
                            color: status !== "VOID" ? "black" : "#ADADA6",
                          }}
                        >
                          {status && typeof status === "string"
                            ? status.toProperCase()
                            : ""}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default withRedux(Invoices);
